import { DocPage } from "./pages/doc";
import { EditPage } from "./pages/edit";
import { HomePage } from "./pages/home";
import { DocClient } from "./shared/docclient";
import { handleError, MIVPage, runAsync } from "./shared/pages";
import "./styles/global.css";
import { initializeTabControl } from "./pages/doc/tabcontrol";
import { ErrorMessage } from "@1oo4/miv";

const routes = new Map<string, MIVPage>();
const regx = new RegExp("^/([a-z]|[A-Z])+/?");

const pageHome = new HomePage();
const pageDoc = new DocPage();
const pageEdit = new EditPage();
MIVPage.initializePages(routes);

initializeTabControl();

function getPageName(withSlashes: string | undefined | null): string {
    if (withSlashes === undefined || withSlashes == null || withSlashes.length <= 0) {
        return "";
    }
    if (withSlashes[0] == "/") {
        if (withSlashes.length <= 1) return "";
        withSlashes = withSlashes.substring(1);
    }
    if (withSlashes[withSlashes.length - 1] == "/") {
        if (withSlashes.length <= 1) return "";
        withSlashes = withSlashes.substring(0, withSlashes.length - 1);
    }
    return withSlashes;
}

export async function navigateAsync(path: string, pushState: boolean = true): Promise<void> {
    const result = regx.exec(path);
    let page: MIVPage;
    if (result === undefined || result == null || result.length <= 0) {
        page = pageHome;
    } else {
        page = routes.get(getPageName(result[0])) ?? pageHome;
    }
    let actualPath: string;
    if (page == window.currentPage) {
        actualPath = page.getSamePagePath(path);
    } else {
        window.currentPage?.close();
        window.currentPage = page;
        actualPath = await page.openAsync_return_actual_path(path);
        MIVPage.currentPageChanged(page);
    }
    if (pushState) window.history.pushState({}, "", actualPath);
    await page.navigatePathAsync(actualPath);
}

// Handle back/forward browser buttons
window.addEventListener("popstate", (evt) =>
    runAsync(navigateAsync(window.location.pathname, false))
);

// Intercept all <a> clicks to use client-side navigation
document.addEventListener("click", (e) => {
    const target = (e.target as HTMLElement).closest("a");
    if (!target) return;
    if (target.hasAttribute('prevent-navigation')) {
        e.preventDefault();
    } else {
        const href = target.getAttribute("href");
        if ((!href) || href.startsWith("http") || href.startsWith("//") || href.startsWith("www")) return;
        e.preventDefault();
        runAsync(navigateAsync(href));
    }
});
export function preventNavigation(a: HTMLAnchorElement): void {
    a.toggleAttribute('prevent-navigation');
}

export function updateSignInStatus() {
    const editNav = document.getElementById("nav_edit");
    if (editNav) {
        if (window.client === undefined || window.client.UserID <= 0) {
            editNav.style.display = "none";
        } else {
            editNav.style.display = '';
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    document.getElementById("signin_button_cancel")?.addEventListener("click", () => {
        const signinPanel = document.getElementById("signin_panel");
        if (signinPanel) signinPanel.style.display = "none";
    });
    document.getElementById("signin_button")?.addEventListener("click", async () => {
        const loginInput = document.getElementById("login_input") as HTMLInputElement;
        const pswInput = document.getElementById("password_input") as HTMLInputElement;
        if (loginInput && pswInput) {
            if (loginInput.value && loginInput.value.length > 0 && pswInput.value && pswInput.value.length > 0) {
                const error = await runAsync<string | undefined>((async function (): Promise<string | undefined> {
                    const client = await DocClient.getClientAsync();
                    if (client instanceof DocClient) {
                        const error = await client.SignInAsync(loginInput.value, pswInput.value);
                        if (error === undefined) {
                            return undefined;
                        } else {
                            console.log("error signin :");
                            console.log(error);
                            return "error, see console for details";
                        }
                    } else {
                        return "failed to connect to the server";
                    }
                })());
                if (error && error.length > 0) {
                    alert(error);
                } else {
                    alert("signin success");
                    const signinPanel = document.getElementById("signin_panel");
                    if (signinPanel) signinPanel.style.display = "none";
                }
                updateSignInStatus();
            } else {
                alert("please entar a login/password")
            }
        }
    });
});

async function getClientAndGenerateDocHTML(): Promise<ErrorMessage | undefined> {
    const client = await DocClient.getClientAsync();
    if (client instanceof ErrorMessage) {
        return client;
    }
    return await client.DocRoot.DownloadWholeDocHTMLAsync();
}

async function getClientAndGenerateDocMarkdown(): Promise<ErrorMessage | undefined> {
    const client = await DocClient.getClientAsync();
    if (client instanceof ErrorMessage) {
        return client;
    }
    return await client.DocRoot.DownloadWholeDocMarkdownAsync();
}

(document.getElementById("generate_single_html") as HTMLButtonElement).onclick = async () => {
    const error = await runAsync(getClientAndGenerateDocHTML());
    handleError(error);
};
(document.getElementById("generate_single_md") as HTMLButtonElement).onclick = async () => {
    const error = await runAsync(getClientAndGenerateDocMarkdown());
    handleError(error);
};

// Resolve the current URL on startup
runAsync(navigateAsync(window.location.pathname));